// https://vuex.vuejs.org/en/actions.html

import userService from '@/services/Admin/userService'
import store from '@/store'

export default {
  async RefreshUsers (context, loadingMessage) {
    var loadingId = await store.dispatch('AddLoadingMessage', loadingMessage || 'Loading')
    var apiResult = await userService.getAll()
    if (apiResult.success) {
      context.commit('refreshUsers', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async CreateUser (context, user, loadingMessage) {
    var loadingId = await store.dispatch('AddLoadingMessage', loadingMessage || 'Loading')
    var apiResult = await userService.create(user)
    if (apiResult.success) {
      context.commit('UpdateUser', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async UpdateUser (context, user, loadingMessage) {
    var loadingId = await store.dispatch('AddLoadingMessage', loadingMessage || 'Loading')
    var apiResult = await userService.update(user)
    if (apiResult.success) {
      context.commit('UpdateUser', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
}
